import { format, isValid, parseISO } from 'date-fns';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';

export const MAX_VISIBLE_CO_TRAVELERS = 5;

export const formatTripDate = (dateStr: string): string => {
  try {
    const date = parseISO(dateStr);
    return isValid(date) ? format(date, 'MMM yyyy') : dateStr;
  } catch {
    return dateStr;
  }
};

export const resolveCountries = (codes: string[], countryMap: CountryCodeMap | undefined): string[] => (
  codes.map((code) => countryMap?.[code] ?? code)
);

/** Returns "Country" for one country, "N Countries" for many. */
export const formatCountriesLabel = (countries: string[]): string => (
  countries.length === 1
    ? countries[0]
    : `${countries.length} Countries`
);
